import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ProjectAddon } from "./getProjectAddons.request";

export const createProjectAddon = ({
  organizationId,
  projectId,
  data
}: {
  organizationId: string;
  projectId: string;
  data: { type: string; sku: string };
}) =>
  apiProxyRequest<ProjectAddon>(
    `/organizations/${organizationId}/projects/${projectId}/addons`,
    "POST",
    data
  );
